import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/pinterest-pin.constant";

export {
    addPinterestPins,
    addSinglePinterestPin,
    updateSinglePinterestPin,
    getSinglePinterestPin,
    getAllPinterestPins,
    searchPinterestPins,
    searchPinterestPinsWithSearchCriteria,
    preparePinterestPinsList
}

const collectionName = 'pinterest-pins';
const collectionReference = collection(fireStoreDB, collectionName);

const addPinterestPins = (pinterestPins) => {
    return Promise.map(pinterestPins, async pinterestPin => {
        await addSinglePinterestPin(pinterestPin);
    });
}

const addSinglePinterestPin = (pinterestPin) => {
    pinterestPin.createdAt = new Date();
    pinterestPin.updatedAt = pinterestPin.createdAt;
    return addDoc(collectionReference, pinterestPin);
}

const updateSinglePinterestPin = (pinterestPin) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestPin.id);
    pinterestPin.updatedAt = new Date();
    return setDoc(documentReference, pinterestPin);
}

const getSinglePinterestPin = async (pinterestPinId) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestPinId);
    const pinterestPinDoc = await getDoc(documentReference);
    return prepareSinglePinterestPin(pinterestPinDoc);
}

const getAllPinterestPins = async () => {
    let searchQuery = query(collectionReference);
    const pinterestPinsResult = await getDocs(searchQuery);
    return preparePinterestPinsList(pinterestPinsResult);
}

const searchPinterestPins = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const pinterestPinResult = await getDocs(searchQuery);
    return preparePinterestPinsList(pinterestPinResult);
}

const searchPinterestPinsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPinterestPinsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const pinterestPinResult = await getDocs(searchQuery);
    return preparePinterestPinsList(pinterestPinResult);
}

const preparePinterestPinsList = (pinterestPinResult) => {
    const pinterestPinsList = [];

    _.forEach(pinterestPinResult.docs, pinterestPinDoc => {
        pinterestPinsList.push(prepareSinglePinterestPin(pinterestPinDoc));
    });

    return pinterestPinsList;
}


const prepareSinglePinterestPin = (pinterestPinDoc) => {
    const pinterestPin = pinterestPinDoc.data();
    pinterestPin.id = pinterestPinDoc.id;
    return pinterestPin;
}
